import React, { useState, useRef, useEffect } from 'react';

import { Box } from '@chakra-ui/react';
import { useTheme } from '@emotion/react';

import { EmptyStar, FilledStar, Star, StarFilled } from 'assets/assetsV1/iconComponents';

export const BaseStarRating = ({
  precision = 1,
  maxRating = 5,
  FilledIcon = FilledStar,
  EmptyIcon = EmptyStar,
  rating,
  label = '',
  disabled = false,
  isRequired = false,
  enableValidation = false,
  handleChange = () => {},
}) => {
  const [activeStar, setActiveStar] = useState(rating);

  // const validationErrorText =
  //   enableValidation && isRequired && !rating ? `${label} (Required)` : '';
  const { colors } = useTheme();

  useEffect(() => {
    setActiveStar(rating);
  }, [rating]);

  const [hoverActiveStar, setHoverActiveStar] = useState(-1);
  const [isHovered, setIsHovered] = useState(false);
  const ratingContainerRef = useRef(null);

  const calculateRating = (e) => {
    const { width, left } = ratingContainerRef.current.getBoundingClientRect();
    const percent = (e.clientX - left) / width;
    const numberInStars = percent * maxRating;
    const nearestNumber = Math.round((numberInStars + precision / 2) / precision) * precision;
    return Number(nearestNumber.toFixed(precision.toString().split('.')[1]?.length || 0));
  };

  const handleClick = (e) => {
    if (!disabled) {
      const newRating = calculateRating(e);
      setIsHovered(false);
      setActiveStar(newRating);
      handleChange(newRating);
    }
  };

  const handleMouseMove = (e) => {
    if (!disabled) {
      setIsHovered(true);
      setHoverActiveStar(calculateRating(e));
    }
  };

  const handleMouseLeave = (e) => {
    if (!disabled) {
      setHoverActiveStar(-1); // Reset to default state
      setIsHovered(false);
    }
  };

  return (
    <Box>
      {/* <TextBodyMedium
        color={validationErrorText ? colors.text.g1 : colors.text.g3}
      >
        {validationErrorText ? validationErrorText : label}
      </TextBodyMedium> */}

      <Box
        sx={{
          display: 'inline-flex',
          gap: '6px',
        }}
        onClick={handleClick}
        onMouseMoveCapture={handleMouseMove}
        onMouseOut={handleMouseLeave}
        ref={ratingContainerRef}
        opacity={disabled ? '0.5' : '1'}
      >
        {[...new Array(maxRating)].map((arr, index) => {
          const activeState = isHovered ? hoverActiveStar : activeStar;
          const showEmptyIcon = activeState === -1 || activeState < index + 1;

          return showEmptyIcon ? (
            <Star key={index} boxSize="25px" color={colors.text.g2} />
          ) : (
            <StarFilled key={index} boxSize="25px" color={colors.button.blue.focus} />
          );
        })}
      </Box>
    </Box>
  );
};
